export default function () {
  if (this.$route.name === 'EditFaq') {
    this.loadFaq()
  }
}
